export default "__VITE_ASSET__DKwNBysc__"